import { useExpertUniversityConfiguration, useExpertUniversityStore } from "@expert/expert-university";
import { Button, Tooltip } from "@mantine/core";
import { IconSandbox } from "@tabler/icons-react";

export function LaunchCallSandboxButton() {
    const { setTaskInSandbox, trainingPartner, sandboxProfileId } = useExpertUniversityConfiguration();
    const { eventBus } = useExpertUniversityStore.getState();
    return (
        <Tooltip label={`View call screen in training mode`} withArrow position="bottom">
            <Button
                variant="filled"
                leftSection={IconSandbox && <IconSandbox size={16} />}
                onClick={() => {
                    setTaskInSandbox(true);
                    eventBus?.emit("start-simulation-training", {
                        profileId: sandboxProfileId,
                        partner: trainingPartner,
                        isSandbox: true,
                    });
                }}
            >
                Launch Sandbox
            </Button>
        </Tooltip>
    );
}
